import React, { useState, useEffect } from "react";
import Modal from "../elements/Modal";
import { horseService } from "../../api/horses.service";
import TreeItem from "../elements/TreeItem";

const FamilyModal = ({ isOpenModels, setIsOpenModels, dataLot }) => {
	const [ancestry, setAncestry] = useState({});
	const [loading, setLoading] = useState(false);

	useEffect(() => {
		setAncestry({});
		if (!dataLot) return;

		const loadAncestry = async () => {
			setLoading(true);
			try {
				const response = await horseService.ancestry(dataLot.value);
				if (response?.ancestry?.length) {
					const mapped = {};
					response.ancestry.forEach((item) => {
						mapped[item.position] = item.ancestry_horse;
					});
					setAncestry(mapped);
				}
			} catch (error) {
				console.error("Error fetching ancestry:", error);
			} finally {
				setLoading(false);
			}
		};

		loadAncestry();
	}, [dataLot]);

	if (!isOpenModels) return null;

	if (loading) {
		return (
			<Modal isOpen={isOpenModels} className="Modal__sponsor-container">
				<div className="sponsor-modal">
					<div className="sponsor-modal__header">
						<p className="left">Family</p>
						<div
							className="sponsor-modal__close"
							onClick={() => setIsOpenModels(false)}
						>
							<i className="fa fa-times"></i>
						</div>
					</div>
					<div className="sponsor-modal__content">
						<p className="subtex is-light-weight">
							Loading elements...
						</p>
					</div>
				</div>
			</Modal>
		);
	}

	return (
		<Modal
			isOpen={isOpenModels}
			className="Modal__sponsor-container"
			fullScreen
		>
			<div className="sponsor-modal">
				<div className="sponsor-modal__header">
					<p className="left">Family</p>
					<div
						className="sponsor-modal__close"
						onClick={() => setIsOpenModels(false)}
					>
						<i className="fa fa-times"></i>
					</div>
				</div>

				<div className="sponsor-modal__content">
					{/* Usamos "small-tree" en vez de "tree" */}
					<div className="small-tree flexer flexer-nowrap">
						{/* Columna 1: caballo principal */}
						<div className="small-tree__col" col="1">
							<div className="small-tree__col__row flexer flexer-vcenter">
								<TreeItem
									isSmall // <-- pasamos el prop
									type="main"
									value={dataLot?.label || "No horse"}
								/>
							</div>
						</div>

						{/* Columna 2: Posiciones 1 y 2 */}
						<div className="small-tree__col" col="2">
							{[1, 2].map((pos) => (
								<div
									key={`pos-${pos}`}
									className="small-tree__col__row flexer flexer-vcenter"
								>
									<TreeItem
										isSmall // <-- pasamos el prop
										type="child"
										value={
											ancestry[pos]?.display_name || ""
										}
									/>
								</div>
							))}
						</div>

						{/* Columna 3: Posiciones 3,4,5,6 */}
						<div className="small-tree__col" col="3">
							{[3, 4, 5, 6].map((pos) => (
								<div
									key={`pos-${pos}`}
									className="small-tree__col__row flexer flexer-vcenter"
								>
									<TreeItem
										isSmall
										type="child"
										value={
											ancestry[pos]?.display_name || ""
										}
									/>
								</div>
							))}
						</div>

						{/* Columna 4: Posiciones 7..14 */}
						<div className="small-tree__col" col="4">
							{Array.from({ length: 8 }, (_, i) => i + 7).map(
								(pos) => (
									<div
										key={`pos-${pos}`}
										className="small-tree__col__row flexer flexer-vcenter"
									>
										<TreeItem
											isSmall
											type="child"
											value={
												ancestry[pos]?.display_name ||
												""
											}
										/>
									</div>
								)
							)}
						</div>

						{/* Columna 5: Posiciones 15..30 */}
						<div className="small-tree__col" col="5">
							{Array.from({ length: 16 }, (_, i) => i + 15).map(
								(pos) => (
									<div
										key={`pos-${pos}`}
										className="small-tree__col__row flexer flexer-vcenter"
									>
										<TreeItem
											isSmall
											type="child"
											value={
												ancestry[pos]?.display_name ||
												""
											}
										/>
									</div>
								)
							)}
						</div>
					</div>
				</div>
			</div>
		</Modal>
	);
};

export default FamilyModal;
